import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'shared-taxi'
AdminRouter.addRoute({
  path: `/${base}`,
  name: `${base}`,
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `${base}`,
  order: 20,
  header: $vm => $vm.$t(`general.menu_main`),
  text: $vm => $vm.$t('bookings.shared_transfer'),
  route: {
    name: `${base}`,
  },
  icon: 'icon-share3',
  permission: () => true,
})

messageGroups.push('attributes')
messageGroups.push('bookings')
messageGroups.push('vehicles')
